import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';

@Component({
    selector: 'tidy-bar',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./bar.component.scss'],
    template: `
    @if (value > 0) {
      <mat-progress-bar mode="determinate"  [value]="value" [ngClass]="color"></mat-progress-bar>
    }
    @if (value === 0) {
      <div>-</div>
    }
    `,
    standalone: false
})

export  class BarComponent implements OnInit {


  @Input() disableColor: boolean;
  @Input() value = 1;
  color: string;

  ngOnInit() {
    if (!this.disableColor) {
      this.color = this.getColor(this.value);
    }
  }

  getColor(value: number): string {
    if (value > rangeValues.MEDIUM) {
      return 'tidy-green';
    } else if (value > rangeValues.LOW) {
      return 'orange';
    } else {
      return 'red';
    }
  }
}

export const rangeValues = {
  LOW: 33,
  MEDIUM: 66,
  HIGH: 100
};
